
/**
 * SEO 配置 - models (日本語)
 */

export default {
    veo_3_1: {
        title: 'Google Veo 3.1 - フラッグシップAI動画ジェネレーター | WeryAI',
        description: 'Google Veo 3.1：ネイティブオーディオとフレームコントロールを備えたフラッグシップAI動画モデル。',
        keywords: 'Google Veo 3.1, フラッグシップAI動画, AI動画ジェネレーター, WeryAI',
    },
    veo_3: {
        title: 'Google Veo 3 - 高品質AI動画生成 | WeryAI',
        description: 'Google Veo 3で高品質AI動画を生成。強力なモーション一貫性とネイティブオーディオをサポート。',
        keywords: 'Veo 3, Google Veo, AI動画制作, テキストから動画, WeryAI',
    },
    veo_3_fast: {
        title: 'Google Veo 3 Fast - 超高速AI動画生成 | WeryAI',
        description: 'Google Veo 3 Fastで高画質AI動画を素早く生成。キャラクター一貫性と超高速レンダリングをサポート。',
        keywords: 'Veo 3 Fast, 超高速AI動画, キャラクター一貫性, テキストから動画, WeryAI',
    },
    sora_2: {
        title: 'OpenAI Sora 2 - 物理シミュレーション級AI動画生成 | WeryAI',
        description: 'OpenAI Sora 2で物理法則に準拠した超リアルな動画を生成。マルチショット叙事と精密な制御をサポート。',
        keywords: 'Sora 2, OpenAI Sora, 物理シミュレーション, リアルAI動画, テキストから動画, WeryAI',
    },
    weryai_video_1: {
        title: 'WeryAI Video 1.0 - フラッグシップ・ネイティブAI動画ジェネレーター | WeryAI',
        description: 'WeryAI Video 1.0：ネイティブマルチショット叙事、スマート画像から動画、物理級モーションシミュレーションをサポートするフラッグシップAI動画モデル。',
        keywords: 'WeryAI Video 1.0, WeryAI ネイティブモデル, AI動画ジェネレーター, マルチショット叙事, 画像から動画, WeryAI',
    },
    weryai_image_2: {
        title: 'WeryAI Image 2 - ネイティブAI画像ジェネレーター | WeryAI',
        description: 'WeryAI Image 2で素晴らしいネイティブAI画像生成！フラッグシップモデル、高度なスタイル制御とディテール。無料クレジット、カード不要。',
        keywords: 'WeryAI Image 2, ネイティブAI画像生成, フラッグシップAI画像, スタジオ級AI, WeryAI Image 無料, WeryAI Image 2の使い方, WeryAI',
    },
    image_grok_2: {
        title: '無料 Grok 2 - xAI画像ジェネレーター | WeryAI',
        description: 'WeryAIでGrok 2を使ってクリエイティブなAI画像を生成！xAIモデル、芸術的柔軟性とユニークなスタイル。無料クレジット、カード不要。',
        keywords: 'Grok 2, Grok AI, xAI画像生成, AIアート, クリエイティブAI画像, Grok 2 無料, Grok 2の使い方, WeryAI',
    },
    image_nano_banana_2: {
        title: 'Nano Banana 2 画像ジェネレーター | WeryAI',
        description: 'Nano Banana 2はGeminiを搭載し、世界知識とリアルタイム検索を組み合わせ、事実に正確で美しい画像を生成します。高速生成と安定品質、高い制御性を備え、商用制作やマーケティング業務にも最適です。WeryAIで今すぐ無料体験。',
        keywords: 'Nano Banana 2, Google AI, Gemini, AI画像生成, 画像生成, テキストから画像, テキストレンダリング, マルチサブジェクト一貫性, 4K, WeryAI',
        og_title: 'Nano Banana 2 画像ジェネレーター | WeryAI',
        og_description: 'Nano Banana 2はGeminiを搭載し、世界知識とリアルタイム検索を組み合わせ、事実に正確で美しい画像を生成します。高速生成と安定品質、高い制御性を備え、商用制作やマーケティング業務にも最適です。WeryAIで今すぐ無料体験。',
        twitter_title: 'Nano Banana 2 画像ジェネレーター | WeryAI',
        twitter_description: 'Nano Banana 2はGeminiを搭載し、世界知識とリアルタイム検索を組み合わせ、事実に正確で美しい画像を生成します。高速生成と安定品質、高い制御性を備え、商用制作やマーケティング業務にも最適です。WeryAIで今すぐ無料体験。',
        ogImage: 'https://static.weryai.com/growth/image/weryai_ef98c0ea10c77d45e68553c1b6692e5b.webp',
        twitterImage: 'https://static.weryai.com/growth/image/weryai_ef98c0ea10c77d45e68553c1b6692e5b.webp',
        ogImageAlt: 'Nano Banana 2 AI画像生成',
        twitterImageAlt: 'Nano Banana 2 AI画像生成',
    },
    kling_ai: {
        title: 'Kling 2.5 Turbo - トップクラスAI動画ジェネレーター | WeryAI',
        description: 'Kling 2.5 Turboは卓越したカメラワーク制御と感情表現力を提供。映画級AI動画制作の最適な選択。',
        keywords: 'Kling 2.5 Turbo, Kling AI, 映画級動画, カメラワーク制御, 動画生成, WeryAI',
    },
    runway_ai: {
        title: 'Runway Gen-4 - プロAI動画編集・生成 | WeryAI',
        description: 'Runway Gen-4は深層プロンプト理解とスタイル一貫性を備えています。WeryAIで次世代AI動画編集を体験。',
        keywords: 'Runway Gen-4, Runway AI, 動画ジェネレーター, AI動画編集, テキストから動画, WeryAI',
    },
    hailuo_23: {
        title: 'Hailuo 2.3 (MiniMax) - Eコマース＆ダイナミックAI動画 | WeryAI',
        description: 'Hailuo 2.3はダイナミックアクションとEコマース広告に最適化。繊細な表情と物体モーション制御を提供。',
        keywords: 'Hailuo 2.3, Hailuo AI, MiniMax, Eコマース動画, ダイナミックAI動画, WeryAI',
    },
    hailuo_ai: {
        title: 'Hailuo AI動画ジェネレーター - 高度なモーション制御 | WeryAI',
        description: 'Hailuo AIで高度なAI動画を生成。最先端のモーションシミュレーションとリアルなシーンレンダリング機能を搭載。',
        keywords: 'Hailuo AI, Hailuo AI, モーション制御, リアル動画, 動画ジェネレーター, WeryAI',
    },
    pika_2_2: {
        title: 'Pika 2.2 - 高画質・繊細なAIアニメーション生成 | WeryAI',
        description: 'WeryAIでPika 2.2を体験し、クリアでシャープな高画質AIアニメーションを生成。精密なキャラクター制作に最適。',
        keywords: 'Pika 2.2, Pika AI, AIアニメーション, 高画質動画, 動画ジェネレーター, WeryAI',
    },
    seedance: {
        title: 'Seedance AI動画ジェネレーター - ダンス＆モーション制作 | WeryAI',
        description: 'Seedanceでリアルでプロフェッショナルなダンス動画を生成。',
        keywords: 'Seedance, AI動画, WeryAI',
    },
    seedance_2: {

        title: 'Werydance 2.0 - 監督級AI動画生成 | WeryAI',

        description: 'weryai Werydance 2.0は監督級AIビデオ生成フラッグシップモデル。マルチモーダル参照入力、精密な指示追従、ナラティブ一貫性と物理シミュレーションに対応。WeryAIで無料体験。',

        keywords: 'Werydance 2.0, Seedance AI, weryai, 即夢AI, AI動画生成, 監督級制御, マルチモーダル動画, 物理シミュレーション, リップシンク, テキストから動画, 無料AI動画, WeryAI',

        og_title: 'Werydance 2.0 - 監督級AI動画生成 | WeryAI',

        og_description: 'weryai Werydance 2.0は監督級AIビデオ生成フラッグシップモデル。マルチモーダル参照入力、精密な指示追従、ナラティブ一貫性と物理シミュレーションに対応。WeryAIで無料体験。',

        twitter_title: 'Werydance 2.0 - 監督級AI動画生成 | WeryAI',

        twitter_description: 'weryai Werydance 2.0は監督級AIビデオ生成フラッグシップモデル。マルチモーダル参照入力、精密な指示追従、ナラティブ一貫性と物理シミュレーションに対応。WeryAIで無料体験。',



        ogImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        twitterImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        ogImageAlt: 'Werydance 2.0 AI Video Generator',

        twitterImageAlt: 'Werydance 2.0 AI Video Generator',

    },
    wan_2_6: {
        title: 'Wan 2.6 | Alibabaの先進的AI動画ジェネレーター | WeryAI',
        description: 'Wan 2.6 は、Alibabaの最新フラッグシップ多モーダルAI動画生成モデル。シネマティックな1080p品質、ネイティブな音声・映像同期、スマートなマルチショット叙事機能を搭載。WeryAIで無料でお試し。',
        keywords: 'Wan 2.6, Alibaba Wan 2.6, AI動画ジェネレーター, マルチモーダル動画モデル, テキストから動画, 画像から動画, オーディオ同期, WeryAI Wan 2.6',
    },
    image_gpt_4o: {
        title: '無料 GPT-4o - OpenAI画像ジェネレーターを試す | WeryAI',
        description: 'WeryAIでGPT-4oを使って会話から画像を作成！OpenAIの精密テキストレンダリングと高品質結果。無料クレジット、カード不要。',
        keywords: 'GPT-4o, GPT-4o画像, OpenAI画像生成, 会話型AIアート, GPT-4o 無料, GPT-4o画像の使い方, WeryAI',
    },
    image_nano_banana_pro: {
        title: '無料 Nano Banana Pro - AI画像ジェネレーター | WeryAI',
        description: 'WeryAIでNano Banana Proを使って最高忠実度のAI画像！Midjourney匹敵の品質で優れたプロンプト追従。無料クレジット、カード不要。',
        keywords: 'Nano Banana Pro, Gemini 3.0 Pro, Google AI画像, 推論AI画像, 4K AI画像, Nano Banana Pro 無料, Nano Banana Proの使い方, WeryAI',
    },
    image_nano_banana: {
        title: '無料 Nano Banana - AI画像ジェネレーター | WeryAI',
        description: 'WeryAIでNano Bananaを使って簡単にAI画像を作成！万能で高速なAI画像モデル。無料クレジット、カード不要。',
        keywords: 'Nano Banana, Gemini 2.5 Flash, Google AI画像, 高速AI画像生成, キャラクター一貫性, Nano Banana 無料, Nano Bananaの使い方, WeryAI',
    },
    image_flux: {
        title: '無料 FLUX - AI画像ジェネレーターを試す | WeryAI',
        description: 'WeryAIでFLUXを使って素晴らしいAI画像を生成！Stable Diffusionチーム制作、卓越した画質とスタイル制御。無料クレジット、カード不要。',
        keywords: 'FLUX, FLUX AI, Black Forest Labs, AI画像生成, テキストから画像, AIアート, FLUX AI画像生成, FLUX 無料, FLUXの使い方, WeryAI',
    },
    image_flux_kontext: {
        title: '無料 FLUX Kontext - プロAI画像エディター | WeryAI',
        description: 'WeryAIでFLUX Kontextを使ったプロレベルのAI画像編集！高精度プロンプト追従、高度なタイポグラフィ、マルチステップ編集。無料クレジット、カード不要。',
        keywords: 'FLUX Kontext, FLUX.1 Kontext, AI画像エディター, プロAI画像, タイポグラフィAI, FLUX Kontext 無料, FLUX Kontextの使い方, WeryAI',
    },
    image_imagen: {
        title: '無料 Imagen 4 - Google AI画像ジェネレーター | WeryAI',
        description: 'WeryAIでGoogle Imagen 4を使ってフォトリアルなAI画像を作成！多彩なスタイル制御と正確なテキスト生成。無料クレジット、カード不要。',
        keywords: 'Imagen 4, Google Imagen, Google AI画像, テキストから画像, フォトリアルAI, Imagen 無料, Imagen 4の使い方, WeryAI',
    },
    image_qwen_image: {
        title: '無料 Qwen Image - Alibaba AI画像モデル | WeryAI',
        description: 'WeryAIでQwen Imageを使って多言語AIアートを生成！Alibabaオープンソースモデル、優れたテキストレンダリング。無料クレジット、カード不要。',
        keywords: 'Qwen Image, Alibaba AI, オープンソースAI画像, 多言語テキストレンダリング, Qwen Image 無料, Qwen Imageの使い方, WeryAI',
    },
    image_wan_ai: {
        title: '無料 Wan AI - Alibaba画像ジェネレーターを試す | WeryAI',
        description: 'WeryAIでWan AIを使って高忠実度AI画像を作成！Alibabaモデル、精密プロンプト追従とフォトリアルレンダリング。無料クレジット、カード不要。',
        keywords: 'Wan AI, Wan 2.5, Alibaba AI画像, テキストから画像, フォトリアルAI, Wan AI 無料, Wan AIの使い方, WeryAI',
    },
    image_seendream: {
        title: '無料 Seedream 4.0 - ByteDance画像AI | WeryAI',
        description: 'WeryAIでSeedream 4.0を使って超高速AI画像生成！ByteDanceモデル、多様な芸術スタイルとバッチ処理。無料クレジット、カード不要。',
        keywords: 'Seedream, Seedream 4.0, ByteDance AI画像, 超高速AI画像, 芸術スタイルAI, Seedream 無料, Seedreamの使い方, WeryAI',
    },
    image_dreamina: {
        title: '無料 Dreamina 4.0 - マルチモーダル画像AI | WeryAI',
        description: 'WeryAIでDreamina 4.0を使ってマルチモーダルAI画像作成！スケッチ変換、スタイル転写、キャラクター融合対応。無料クレジット、カード不要。',
        keywords: 'Dreamina 4.0, ByteDance AI画像, マルチモーダルAI画像, スケッチ変換, スタイル転写, Dreamina 無料, Dreamina 4.0の使い方, WeryAI',
    },
    image_seedream_4_5: {
        title: '無料 Seedream 4.5 - ByteDance画像AI | WeryAI',
        description: 'WeryAIでSeedream 4.5を使ってフラッグシップAI画像生成！ByteDance最新、精密タイポグラフィとマルチ画像融合。無料クレジット、カード不要。',
        keywords: 'Seedream 4.5, ByteDance AI画像, フラッグシップAI画像, タイポグラフィレンダリング, マルチ画像融合, Seedream 4.5 無料, Seedream 4.5の使い方, WeryAI',
    },
    image_seedream_5_0: {
        title: 'Seedream 5.0 画像ジェネレーター | WeryAI',
        description: 'Seedream 5.0はByteDanceのAIビジュアル分野における最高傑作です。ネイティブ8K超精細画質、究極のセマンティック理解、マルチサブジェクト構図、テキストレンダリング2.0を搭載。WeryAIで無料体験。',
        keywords: 'Seedream 5.0, ByteDance, AI画像生成, 8K画像生成, テキストから画像, セマンティック理解, マルチサブジェクト構図, テキストレンダリング, WeryAI',
        og_title: 'Seedream 5.0 画像ジェネレーター | WeryAI',
        og_description: 'Seedream 5.0はByteDanceのAIビジュアル分野における最高傑作です。ネイティブ8K超精細画質、究極のセマンティック理解、マルチサブジェクト構図、テキストレンダリング2.0を搭載。WeryAIで無料体験。',
        twitter_title: 'Seedream 5.0 画像ジェネレーター | WeryAI',
        twitter_description: 'Seedream 5.0はByteDanceのAIビジュアル分野における最高傑作です。ネイティブ8K超精細画質、究極のセマンティック理解、マルチサブジェクト構図、テキストレンダリング2.0を搭載。WeryAIで無料体験。',
        ogImage: 'https://static.weryai.com/growth/image/weryai_871e99f0d8f52b7abdb1d410e76ae64d.png',
        twitterImage: 'https://static.weryai.com/growth/image/weryai_871e99f0d8f52b7abdb1d410e76ae64d.png',
        ogImageAlt: 'Seedream 5.0 AI画像生成',
        twitterImageAlt: 'Seedream 5.0 AI画像生成',
    },
    image_recraft_v4_vector: {
        title: 'Recraft V4 Vector - プロフェッショナル真ベクターAIグラフィックスジェネレーター | WeryAI',
        description: 'Recraft V4 Vectorは、Recraft.aiによるプロフェッショナルグレードのAIベクターグラフィックスジェネレーターで、編集可能なSVG真ベクターを生成し、無損失スケーリング、精密なタイポグラフィ、ブランドスタイル制御を提供します。WeryAIで今すぐ無料でお試しください。',
        keywords: 'Recraft V4 Vector, AIベクター生成, SVGジェネレーター, 真ベクター, ロゴデザイン, UIアイコン, ベクターイラスト, Recraft, WeryAI',
    },
    image_midjourney: {
        title: '無料 Midjourney - AIアートジェネレーターを試す | WeryAI',
        description: 'WeryAIでMidjourneyを使ってアーティスティックなAI画像を作成！驚くべき美感と照明品質で有名。無料クレジット、カード不要。',
        keywords: 'Midjourney, Midjourney AI, AIアートジェネレーター, アーティスティックAI画像, Midjourney 無料, Midjourney代替, Midjourneyの使い方, WeryAI',
    },
    runway_4_5: {
        title: 'Runway Gen-4.5 AI動画ジェネレーター - 映画級動画を作成 | WeryAI',
        description: 'WeryAIでRunway Gen-4.5を使い、画像とプロンプトからAI動画を作成。画像から動画に対応し、無料で試せます。',
        keywords: 'Runway Gen-4.5, AI動画ジェネレーター, 映画級AI動画, 物理シミュレーション, Runway AI, WeryAI',
    },
    kling_2_6_pro: {
        title: 'Kling 2.6 Pro AI動画ジェネレーター - 高品質動画制作 | WeryAI',
        description: 'WeryAIでKling 2.6 Proを使用して高品質動画を生成。ネイティブ音声映像生成、1080p映画品質、優れたプロンプト遵守能力。',
        keywords: 'Kling 2.6 Pro, AI動画ジェネレーター, 高品質AI動画, Kling AI, WeryAI',
    },
    video_dreamina_3: {
        title: 'Dreamina 3.0 動画ジェネレーター - 精密なカメラ制御と首尾フレーム指導 | WeryAI',
        description: 'WeryAIでDreamina 3.0（即夢3.0）を使用して映画級AI動画を生成。首尾フレーム精密制御、プロ運鏡と1080p高ダイナミック動画生成をサポート。',
        keywords: 'Dreamina 3.0, 即夢3.0, AI動画ジェネレーター, 運鏡制御, 首尾フレーム制御, ByteDance AI, WeryAI',
    },
    kling_o1: {
        title: 'Kling O1 AI動画ジェネレーター - クリエイティブ動画生成 | WeryAI',
        description: 'WeryAIでKling O1 AI動画ジェネレーターを使用して創造力を解放。想像力豊かでユニークな動画コンテンツの生成に最適。',
        keywords: 'Kling O1, AI動画ジェネレーター, クリエイティブAI動画, Kling AI, WeryAI',
    },
    kling_3_0: {

        title: 'Kling 3.0 - スマート絵コンテAI動画生成 | WeryAI',

        description: 'Kling 3.0はKuaishouの次世代AIビデオフラッグシップモデル。スマート絵コンテ、多言語リップシンク、精密テキストレンダリング、15秒ロング生成に対応。WeryAIで無料体験。',

        keywords: 'Kling 3.0, Kling AI, Kuaishou, AI動画生成, スマート絵コンテ, 多言語リップシンク, テキストレンダリング, テキストから動画, 画像から動画, 無料AI動画, WeryAI',

        og_title: 'Kling 3.0 - スマート絵コンテAI動画生成 | WeryAI',

        og_description: 'Kling 3.0はKuaishouの次世代AIビデオフラッグシップモデル。スマート絵コンテ、多言語リップシンク、精密テキストレンダリング、15秒ロング生成に対応。WeryAIで無料体験。',

        twitter_title: 'Kling 3.0 - スマート絵コンテAI動画生成 | WeryAI',

        twitter_description: 'Kling 3.0はKuaishouの次世代AIビデオフラッグシップモデル。スマート絵コンテ、多言語リップシンク、精密テキストレンダリング、15秒ロング生成に対応。WeryAIで無料体験。',



        ogImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        twitterImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        ogImageAlt: 'Kling 3.0 AI Video Generator',

        twitterImageAlt: 'Kling 3.0 AI Video Generator',

    },
    vidu_q3: {

        title: 'Vidu Q3 - 16秒ネイティブ音声動画AI生成 | WeryAI',

        description: 'Vidu Q3は世界初の16秒ネイティブ音声動画モデル。スマート絵コンテと自動カット、中英日の精密テキストレンダリング、多言語リップシンクに対応。WeryAIで無料体験。',

        keywords: 'Vidu Q3, Vidu AI, 生数科技, AI動画生成, 16秒音声動画, ネイティブ音声動画, スマート絵コンテ, テキストレンダリング, リップシンク, テキストから動画, 無料AI動画, WeryAI',

        og_title: 'Vidu Q3 - 16秒ネイティブ音声動画AI生成 | WeryAI',

        og_description: 'Vidu Q3は世界初の16秒ネイティブ音声動画モデル。スマート絵コンテと自動カット、中英日の精密テキストレンダリング、多言語リップシンクに対応。WeryAIで無料体験。',

        twitter_title: 'Vidu Q3 - 16秒ネイティブ音声動画AI生成 | WeryAI',

        twitter_description: 'Vidu Q3は世界初の16秒ネイティブ音声動画モデル。スマート絵コンテと自動カット、中英日の精密テキストレンダリング、多言語リップシンクに対応。WeryAIで無料体験。',



        ogImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        twitterImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        ogImageAlt: 'Vidu Q3 AI Video Generator',

        twitterImageAlt: 'Vidu Q3 AI Video Generator',

    },
    image_gpt_image_1_5: {
        title: '無料 GPT Image 1.5 - OpenAIアートジェネレーター | WeryAI',
        description: 'WeryAIでGPT Image 1.5を使って次世代AIアートを作成！OpenAI最新画像モデル、創造性とディテールが向上。無料クレジット、カード不要。',
        keywords: 'GPT Image 1.5, OpenAI画像モデル, AIアートジェネレーター, 次世代AI画像, GPT Image 1.5 無料, GPT Image 1.5の使い方, WeryAI',
    },
}
